import axios from 'axios';
import { getNonGwApiRoot } from '../../../constants/ParamountReactConstants';

export function fetchInvalidPartAttributes(brandId: number) {
  return {
    type: 'FETCH_INVALID_PART_ATTRIBUTES',
    payload: axios.get(
      `${getNonGwApiRoot()}/items/ai_quick_fixes/bulk/invalid_part_attribute?brand_id=${brandId}`
    ),
    meta: { brandId },
  };
}

export function fetchInvalidPartAttributeValues(brandId: number) {
  return {
    type: 'FETCH_INVALID_PART_ATTRIBUTE_VALUES',
    payload: axios.get(
      `${getNonGwApiRoot()}/items/ai_quick_fixes/bulk/invalid_part_attribute_value?brand_id=${brandId}`
    ),
    meta: { brandId },
  };
}

export function acceptBulkInvalidAttribute(
  referenceIds: number[],
  aiSuggestion: string,
  analysisTypeId: number
) {
  return {
    type: 'ACCEPT_BULK_INVALID_ATTRIBUTE',
    payload: axios.post(`${getNonGwApiRoot()}/items/ai_quick_fixes/bulk/accept`, {
      segment_id: 2,
      reference_ids: referenceIds,
      ai_suggestion: aiSuggestion,
      analysis_type_id: analysisTypeId,
    }),
    meta: { referenceIds, aiSuggestion, analysisTypeId },
  };
}

export function declineBulkInvalidAttribute(referenceIds: number[], analysisTypeId: number) {
  return {
    type: 'DECLINE_BULK_INVALID_ATTRIBUTE',
    payload: axios.post(`${getNonGwApiRoot()}/items/ai_quick_fixes/bulk/decline`, {
      analysis_type_id: analysisTypeId,
      reference_ids: referenceIds,
    }),
    meta: { referenceIds, analysisTypeId },
  };
}
